import React from "react";
import { useState } from 'react';
import './Navbar.css'

export default function Navbar({ OnGetStarted }) {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
    };
    return (
        <nav className="navbar">
            <div className="navbar-container">
                <a href="https://kshitijks.com" target="_blank" rel="noreferrer" className="navbar-brand">
                    FaceReco
                </a>
                <button className="nav-toggle" onClick={toggleNav}>
                    {isNavOpen ? '✕' : '☰'}
                </button>
                <ul className={`navbar-menu ${isNavOpen ? 'show' : ''}`}>
                    <li><a href="./">Features</a></li>
                    <li><a href="./">Pricing</a></li>
                    <li><a href="./">Documentation</a></li>
                    <li><a href="./">About</a></li>
                    <li>
                        <button className="get-started" onClick={OnGetStarted}>
                            Get Started
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
}